import { render, staticRenderFns } from "./TemplateCard.vue?vue&type=template&id=a5c54cec&scoped=true&"
import script from "./TemplateCard.vue?vue&type=script&lang=js&"
export * from "./TemplateCard.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCard.vue?vue&type=style&index=0&id=a5c54cec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c54cec",
  null
  
)

export default component.exports